/**
 * @author gll
 * 功能：业务组管理功能
 */

import { Service } from '@/tools'
export class BusService<T extends TUser.Bus> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Bus}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：新增业务组
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：分批查询业务组列表
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：分批查询业务组列表
   */
  busGroupAuthCustomer = <K extends T['ApiBusGroupAuthCustomer']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBusGroupAuthCustomer', data)

  /**
   * 功能：查询业务组授权【供应商】数据
   */
  busGroupAuthSupplier = <K extends T['ApiBusGroupAuthSupplier']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBusGroupAuthSupplier', data)

  /**
   * 功能：查看业务组成员
   */
  user = <K extends T['ApiUser']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUser', data)

  /**
   * 功能：查询该组织下未分配到此业务组的成员
   */
  withoutBusUserList = <K extends T['ApiWithoutBusUserList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiWithoutBusUserList', data)

  /**
   * 功能：查询该组织下未分配到此业务组的成员
   */
  updateState = <K extends T['ApiUpdateState']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateState', data)

  /**
   * 功能：添加业务组成员
   *   /api/user/bus/v1/addUser
   */
  addUser = <K extends T['ApiAddUser']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddUser', data)

  /**
   * 功能：保存业务组数据权限
   *  /api/user/bus/v1/data
   */
  data = <K extends T['ApiData']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiData', data)

  /**
   * 功能：查询业务组授权品类数据权限
   *   /api/user/bus/v1/categoryDataDetail
   */
  categoryDataDetail = <K extends T['ApiCategoryDataDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCategoryDataDetail', data)

  /**
   * 功能：查询业务组授权品类数据权限
   *   /api/user/bus/v1/queryCategoryDetail
   */
  queryCategoryDetail = <K extends T['ApiQueryCategoryDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryCategoryDetail', data)

  /**
   * 功能：查询业务组逻辑仓数据权限
   *   /api/user/bus/v1/lwDataDetail
   */
  lwDataDetail = <K extends T['ApiLwDataDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiLwDataDetail', data)
  /**
   * 功能：部门ID获取部门下全部启用业务组列表
   *   /api/user/bus/v1/lwDataDetail
   */
  getBusListByDeptId = <K extends T['ApiGetBusListByDeptId']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetBusListByDeptId', data)
}
